import type { ToolActivity } from "./tool-activity";

export function labelOnly(text: string): ToolActivity {
  return { text, command: null };
}
